import { useTheme } from '@mui/material';
import { useMemo } from 'react';
import { FormAutocompleteProps } from 'src/components';
import { componentsFontSizes } from 'src/constants/layout';

export const emptyOption = { id: '', label: '' };

export function useCommonProps(disabled = false): Partial<FormAutocompleteProps> {
  const theme = useTheme();

  const commonProps = useMemo<Partial<FormAutocompleteProps>>(
    () => ({
      disabled,
      autocompleteProps: {
        forcePopupIcon: false,
        disableClearable: true,
        disabled,
        sx: {
          padding: theme.spacing(0.5, 1),
          borderRadius: theme.shape.borderRadius / 8,
          cursor: 'pointer',
          '&:hover': {
            backgroundColor: theme.palette.custom.OV.sys.surface,
          },
          '& .MuiInput-root': {
            cursor: 'pointer',
          },
          '& .MuiInput-input': {
            userSelect: 'none',
            cursor: 'pointer',
            '&::selection': {
              background: 'transparent',
            },
          },
          '&.Mui-focused': {
            backgroundColor: theme.palette.custom.OV.sys.surfaceContainerHigh,
          },
          '& .MuiOutlinedInput-root.MuiInputBase-sizeSmall': {
            cursor: 'pointer',
            padding: 0,
            border: '0',
            fieldset: {
              display: 'none',
            },
            '.MuiAutocomplete-input': {
              cursor: 'pointer',
              fontSize: '0.9rem',
              padding: 0,
              marginLeft: '0.6rem',
            },
          },
        },
        ListboxProps: {
          sx:
            theme.palette.mode === 'dark'
              ? {
                  background: theme.palette.custom.OV.sys.surfaceContainerHigh,
                  border: `1px solid ${theme.palette.custom.OV.sys.outlineVariant}`,
                  borderRadius: theme.shape.borderRadius / 8,
                }
              : {},
        },
      },
      textFieldProps: {
        size: 'small',
        sx: {
          '& .MuiInput-input': {
            ...theme.typography.body2,
            fontSize: (theme) => theme.utils.important(componentsFontSizes.input),
            paddingInline: 1.6,
            paddingBlock: 1,
            textAlign: 'end',
          },
          '&:hover, &:focus-within': {
            background: (theme) => theme.palette.custom.OV.sys.surface,
          },

          '.Mui-focused &': {
            background: 'inherit',
          },
        },
        disabled,
        placeholder: 'Select Option',
      },
      inputProps: {
        sx: {
          ...theme.typography.body2,
          fontSize: (theme) => theme.utils.important(componentsFontSizes.input),
        },
      },
    }),
    [disabled, theme],
  );

  return commonProps;
}
